<div class="modal fade" id="ChangePassword" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="display: flex;justify-content: center;align-items: center;">
    <div class="modal-content" style="width: 80% !important;">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Change Password</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="changePasswordForm">
        <!-- Current Password -->
        <div class="mb-3 position-relative">
        <label for="currentPassword" class="form-label">Current Password</label>
        <input
            [type]="showCurrentPassword ? 'text' : 'password'"
            id="currentPassword"
            class="form-control pe-5"
            formControlName="currentPassword"
            (blur)="onFieldBlur('currentPassword')"
            (input)="onFieldInput('currentPassword')"
        />
        <span class="toggle-eye" (click)="togglePasswordVisibility('current')" *ngIf="showCurrentPassword">
            <app-feathericon icon="eye-off"></app-feathericon>
        </span>
        <span class="toggle-eye" (click)="togglePasswordVisibility('current')" *ngIf="!showCurrentPassword">
            <app-feathericon icon="eye"></app-feathericon>
        </span>
        <div *ngIf="f['currentPassword'].touched && f['currentPassword'].invalid" class="text-danger small">
            Current password is required.
        </div>
        <div *ngIf="changePasswordForm.errors?.['sameAsCurrent'] && f['newPassword'].touched" class="text-danger small">
            New password cannot be the same as the current password.
        </div>

        </div>

        <hr>

        <!-- New Password -->
        <div class="mb-3 position-relative">
        <label for="newPassword" class="form-label">New Password</label>
        <input
            [type]="showNewPassword ? 'text' : 'password'"
            id="newPassword"
            class="form-control pe-5"
            formControlName="newPassword"
            (blur)="onFieldBlur('newPassword')"
            (input)="onFieldInput('newPassword')"
        />
        <span class="toggle-eye" (click)="togglePasswordVisibility('new')" *ngIf="showNewPassword">
            <app-feathericon icon="eye-off"></app-feathericon>
        </span>
        <span class="toggle-eye" (click)="togglePasswordVisibility('new')" *ngIf="!showNewPassword">
            <app-feathericon icon="eye"></app-feathericon>
        </span>
        <!-- Validation messages -->
        <div *ngIf="f['newPassword'].touched && f['newPassword'].errors?.['required']" class="text-danger small">
            New password is required.
        </div>
        <div *ngIf="f['newPassword'].touched && f['newPassword'].errors?.['minlength']" class="text-danger small">
            Must be at least 8 characters long.
        </div>
        <div *ngIf="f['newPassword'].touched && f['newPassword'].errors?.['pattern']" class="text-danger small">
            Must include:
            <ul class="mb-0 ps-3">
            <li>At least one uppercase letter</li>
            <li>At least one lowercase letter</li>
            <li>At least one number</li>
            <li>At least one special character (e.g. &#64;, $, !, %, *, ?)</li>
            </ul>
        </div>
        </div>

        <!-- Confirm Password -->
        <div class="mb-3 position-relative">
        <label for="confirmPassword" class="form-label">Confirm New Password</label>
        <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            class="form-control pe-5"
            formControlName="confirmPassword"
            (blur)="onFieldBlur('confirmPassword')"
            (input)="onFieldInput('confirmPassword')"
        />
        <span class="toggle-eye" (click)="togglePasswordVisibility('confirm')" *ngIf="showConfirmPassword">
            <app-feathericon icon="eye-off"></app-feathericon>
        </span>
        <span class="toggle-eye" (click)="togglePasswordVisibility('confirm')" *ngIf="!showConfirmPassword">
            <app-feathericon icon="eye"></app-feathericon>
        </span>
        <div *ngIf="f['confirmPassword'].touched && f['confirmPassword'].errors?.['required']" class="text-danger small">
            Confirm password is required.
        </div>
        <div *ngIf="f['confirmPassword'].touched && changePasswordForm.errors?.['mismatch']" class="text-danger small">
            Passwords do not match.
        </div>
        </div>


        <!-- Buttons -->
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-outline-danger w-50" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary w-50" [disabled]="changePasswordForm.invalid" data-bs-dismiss="modal" (click)="onSubmit()">
            Change Password
            </button>
        </div>
        </form>

      </div>

    </div>
  </div>
</div>
